//import * as serviceWorker from './serviceWorker';
import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './i18n';
import { Provider } from 'react-redux';
import MainApp from './MainApp';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store';
import { persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { unitConstants, commonConstants } from './constants';
import { buildInfo, describeBuild } from './utils/buildInfo';

import NetworkService from './NetworkService';
import PiwikPro from '@piwikpro/react-piwik-pro';

NetworkService.setupInterceptors(store);
require('dotenv').config();

// Which build is this? Check the Support section on the User Info page, this
// console line, or window.__SOLO_BUILD__.
window.__SOLO_BUILD__ = {
  version: commonConstants.SOLO_VERSION,
  ...buildInfo,
};
console.info(
  `Solo ${commonConstants.SOLO_VERSION}${
    buildInfo.sha ? ` | ${describeBuild()}` : ' | local build'
  }`,
);

if (process.env.REACT_APP_environment !== 'production') {
  window.liveuSetStatusInterfaces = (interfaces) => {
    if (!Array.isArray(interfaces)) {
      throw new Error('liveuSetStatusInterfaces expects an array');
    }

    store.dispatch({
      type: unitConstants.GET_UNIT_INTERFACE,
      Data: interfaces,
    });
  };
}

// The container ID differs per environment (dev and QA share one, prod has its
// own) and comes from the .env.* file the build uses. If it is missing, Piwik
// logs "Empty tracking code" and stays off.
PiwikPro.initialize(
  process.env.REACT_APP_PIWIK_CONTAINER_ID,
  'https://liveu.containers.piwik.pro',
);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <MainApp />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);
